import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./DropdownWrapper.css";
import { DROPDOWN_DISPLAY_VALUE } from "config/constants";

export default function DropdownWrapper(props) {
  let collapseClass;
  switch (props.collapse) {
    case DROPDOWN_DISPLAY_VALUE.SHOWN:
      collapseClass = styles.collapseShow;
      break;
    case DROPDOWN_DISPLAY_VALUE.HIDDEN:
      collapseClass = styles.collapse;
      break;
    default:
      // HIDDEN
      collapseClass = styles.collapse;
  }
  return (
    <div
      id="main-menu"
      role="menu"
      className={classNames(styles.navbarCollapse, collapseClass, {
        [styles.menuOpen]: props.isOpen || props.isLatestOpen,
      })}
    >
      <ul className={classNames(styles.navbarNav)}>{props.children}</ul>
    </div>
  );
}

DropdownWrapper.propTypes = {
  collapse: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isLatestOpen: PropTypes.bool.isRequired,
};
